import { useCallback, useEffect, useRef, useState } from 'react'
import { isSupabaseConfigured, supabase } from '../lib/supabase'

export function useLiveTable<T>(table: string, orderBy = 'created_at') {
  const [rows, setRows] = useState<T[]>([])
  const requestSequence = useRef(0)
  const mounted = useRef(true)
  const [loading, setLoading] = useState(isSupabaseConfigured)
  const [error, setError] = useState('')
  const reload = useCallback(async () => {
    if (!isSupabaseConfigured) return
    const requestId = ++requestSequence.current
    const { data, error: queryError } = await supabase.from(table).select('*').order(orderBy)
    if (!mounted.current || requestId !== requestSequence.current) return
    if (queryError) setError(queryError.message); else { setRows((data || []) as T[]); setError('') }
    setLoading(false)
  }, [table, orderBy])
  useEffect(() => {
    mounted.current = true
    void reload()
    if (!isSupabaseConfigured) return
    const channel = supabase.channel(`live:${table}`).on('postgres_changes', { event: '*', schema: 'public', table }, () => void reload()).subscribe()
    return () => { mounted.current = false; ++requestSequence.current; void supabase.removeChannel(channel) }
  }, [reload, table])
  return { rows, loading, error, reload }
}
